export enum EnColor {
    green = 'green',
    yellow = 'yellow',
    red = 'red',
    blank = 'blank',
    blue = 'blue'
}
